export default {
    MASCULINO: 'M',
    FEMININO: 'F',
    INDEFINIDO: 'I',
    NAO_SE_APLICA: 'N',
}